<template>
  <div :class="wrap_class">
    <div class="icon_group" v-for="(g_item,index) in show_data_list">
      <div class="icon_item" v-for="icon_item in g_item" @click.prevent="click_item(icon_item)">
        <img :src="icon_item.img" alt />
        <div>{{icon_item.title}}</div>
      </div>
    </div>
  </div>
</template>
<script>
// 设计标准 ICON图片 150X100 ,实际ICON 90X90 水平居中 垂直贴底 , 角标在右上方。
import { getJSON, getJSONP } from "../../api/myaxios";
import click_handler from "../../tools/mgtv/click";
import { openLink } from "../../tools/mgtv/link";
import { urlToWebp} from "../../tools/tpl";
import { HIDE_COMP } from '../../constant/eventbus'

export default {
  name: "NzmIcon",
  components: {},
  props: {
    info: {
      type: Object,
      default: () => {
        return {
          // act_name: "vip_club",
          // act_name_chn: "图标组件",
          // comp_type: "NzmIcon",
          // wrap_style: {
          //   paddingTop: "0px"
          // },
          // title: {
          //   show: true,
          //   title: "我是ICON的标题",
          //   icon: "https://via.placeholder.com/64x32?text=ICON",
          //   more_url: "https://www.mgtv.com"
          // },
          // show_type: "m04"
        };
      }
    }
  },
  data: function() {
    return {
      data_list: [
        // {
        //   img: "https://via.placeholder.com/150x100?text=1",
        //   url: "https://via.placeholder.com/150x100?text=1",
        //   title: "111"
        // },
        // {
        //   img: "https://via.placeholder.com/150x100?text=2",
        //   url: "https://via.placeholder.com/150x100?text=2",
        //   title: "222"
        // },
        // {
        //   img: "https://via.placeholder.com/150x100?text=3",
        //   url: "https://via.placeholder.com/150x100?text=3",
        //   title: "333"
        // },
        // {
        //   img: "https://via.placeholder.com/150x100?text=4",
        //   url: "https://via.placeholder.com/150x100?text=4",
        //   title: "444"
        // },
      ]
    };
  },
  methods: {
    get_detail() {
      getJSON(
        "//vipact3.api.mgtv.com/api/v1/act/img/get",
        {
          act_name: this.info.act_name,
          invoker: window.gact.invoker,
          f_release: window.gact.f_release
        },
        10000,
        false,
        true
      ).then(res => {
        if (!res) {
          return;
        }
        if (res.ret === 0) {
          const list =res.data.list;
          if(list.length === 0){
            console.log('没有内容，隐藏模块', this.info.act_name)
            window.$bus.$emit(HIDE_COMP, this.info.act_name);
            return;
          }
          list.forEach(item=>{
            item.img = urlToWebp(item.img);
          })
          this.data_list = list.slice(0, this.max_num);
        }
      });
    },
    click_item(item) {
      click_handler(`${this.info.act_name_chn}-点击-${item.title}`, () => {
        setTimeout(() => {
          openLink(item.action_info.url);
        }, 200);
      });
    }
  },
  mounted() {
    this.get_detail();
  },

  computed: {
    show_type: function() {
      let show_type = this.info.config.show_type || "m01";
      //m04自动选择样式
      if (show_type === "m04") {
        if (!this.data_list) {
          show_type = "m01";
        } else {
          const len = this.data_list.length;
          if (len <= 4) {
            show_type = "m01"; //只显示1行
          } else if (len <= 6) {
            show_type = "m03"; //滚动
          } else {
            show_type = "m02"; //两行
          }
        }
      }
      return show_type;
    },
    show_data_list: function() {
      if (!this.data_list) {
        return null;
      }
      if (this.show_type === "m01") {
        return [this.data_list.slice(0, 4)];
      } else if (this.show_type === "m02") {
        return [this.data_list.slice(0, 4), this.data_list.slice(4, 8)];
      } else if (this.show_type === "m03") {
        return [this.data_list.slice(0, 8)];
      }
      return this.data_list.slice(0, 4);
    },
    wrap_class: function() {
      return `nzmIconShow nzmIconShow_${this.show_type}`;
    },
    max_num: function () {
      return this.info.config.max_num || 999999;
    }
  }
};
</script>


<style lang="stylus" >
  @import "../../share/mixins.styl"
  .nzmIconShow
    position relative
    width 7.5rem
    display flex
    flex-direction column
    margin-top -.2rem
    .icon_group
      margin-top .06rem
      .icon_item
        display block
        width 1.5rem
        img
          width 1.5rem
          height 1rem
        div
          width 1.5rem
          text-align center
          font-size .22rem
          color #888888
          ellipsis()

  .nzmIconShow_m01
  .nzmIconShow_m02
    .icon_group
        display flex
        justify-content space-around
  .nzmIconShow_m03
    &::-webkit-scrollbar
        display:none;
    .icon_group
      display flex
      flex-shrink: 0
      white-space: nowrap
      overflow-x: auto
      overflow-y hidden
      padding-left .15rem
      -webkit-overflow-scrolling touch
      &::-webkit-scrollbar
        display:none;
        width: 0 !important
        background: transparent;

      .icon_item
        margin-right .15rem



</style>
